import { render, staticRenderFns } from "./TableRegalados.vue?vue&type=template&id=081c1852"
import script from "./TableRegalados.vue?vue&type=script&lang=js"
export * from "./TableRegalados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports